import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M23.3435 11.316C24.629 10.008 23.9202 7.72801 22.1421 7.45201L17.613 6.768C16.9042 6.66 16.2915 6.192 15.9792 5.532L13.9489 1.26C13.5524 0.420004 12.7715 0 12.0027 0C11.2218 0 10.4529 0.420004 10.0565 1.26L8.02616 5.532C7.71381 6.204 7.10112 6.66 6.39231 6.768L1.86319 7.45201C0.0851789 7.71601 -0.635637 10.008 0.661832 11.316L3.94155 14.64C4.45813 15.156 4.68639 15.912 4.56625 16.644L3.79738 21.348C3.55711 22.812 4.67437 24 5.9358 24C6.27218 24 6.62058 23.916 6.94495 23.736L11.0055 21.516C11.3179 21.348 11.6663 21.252 12.0147 21.252C12.3631 21.252 12.7115 21.336 13.0238 21.516L17.0844 23.736C17.4208 23.916 17.7572 24 18.0936 24C19.355 24 20.4723 22.812 20.232 21.348L19.4631 16.644C19.343 15.912 19.5712 15.156 20.0878 14.64L23.3435 11.316ZM18.0455 12.48C16.8441 13.692 16.3035 15.444 16.5798 17.16L17.1084 20.352L14.3573 18.852C13.6365 18.456 12.8196 18.24 11.9907 18.24C11.1617 18.24 10.3568 18.444 9.62397 18.852L6.87286 20.352L7.40146 17.16C7.68979 15.444 7.13716 13.692 5.9358 12.48L3.71329 10.224L6.78876 9.75601C8.44664 9.50401 9.87626 8.424 10.6091 6.864L11.9786 3.96L13.3482 6.864C14.093 8.424 15.5226 9.50401 17.1685 9.75601L20.244 10.224L18.0455 12.48Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
